<div id="personal-content" class="divWhiteBackground" *ngIf="formFieldData">
  <form
    id="cac-personal-details-form"
    class="formStyle"
    [formGroup]="personalForm"
  >
    <div id="cac-personal-div-estimateTime" class="form-group">
      <h2 class="h2-black center" id="cac-personal-tellus-h2">
        {{ formFieldData?.title }}
      </h2>
      <div class="body-black center" data-testid="cac-personal-subtitle">
        <p>{{ formFieldData?.subTitle }}</p>
      </div>
    </div>
    <div class="form-group pt-58">
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-personal-div-firstName"
          class="form-group relative-container"
          [class.has-error]="f.firstName.touched && f.firstName.errors"
        >
          <p
            id="cac-personal-label-firstName"
            htmlFor="{firstName}"
            class="form-field-black control-label"
            [class.validation-error]="f.firstName.touched && f.firstName.errors"
          >
            {{ formFieldData?.formsFields?.firstName?.label }}
          </p>
          <input
            id="cac-personal-firstName"
            type="text"
            placeholder=""
            formControlName="firstName"
            onlyAlphabets
            class="form-control col-left text-capitalize form-field-black"
            aria-labelledby="cac-personal-label-firstName"
            name="firstName"
            maxLength="{{ nameMaxLength }}"
            pattern="[a-zA-Z\s]+"
            (blur)="
              [
                removeTrailingSpaces($event, 'firstName'),
                parseInputAndValidate($event, 'firstName')
              ]
            "
            #firstNameInput
          />
          <span
            *ngIf="
              f.firstName.touched &&
              f.firstName.errors &&
              f.firstName.errors.isNotEmpty
            "
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>

        <div class="mobileOnly mobileDiv">
          <div
            *ngIf="f.firstName.touched && f.firstName.errors?.isNotEmpty"
            role="alert"
            aria-atomic="true"
            data-testid="firstName-empty"
            class="errWidthM required validation-error"
          >
            {{ formFieldData?.formsFields?.firstName?.errors?.fne1 }}
          </div>
          <div
            *ngIf="f.firstName.touched && f.firstName.errors?.isNotProfanity"
            role="alert"
            aria-atomic="true"
            data-testid="firstName-profanity"
            class="errWidthM required validation-error"
          >
            {{ globalText?.errors?.proferr1 }}
          </div>
        </div>
      </div>
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-personal-div-lastName"
          class="form-group relative-container"
          [class.has-error]="f.lastName.touched && f.lastName.errors"
        >
          <p
            id="cac-personal-label-lastName"
            htmlFor="lastName"
            class="form-field-black control-label"
            [class.validation-error]="f.lastName.touched && f.lastName.errors"
          >
            {{ formFieldData?.formsFields?.lastName?.label }}
          </p>
          <input
            id="cac-personal-lastName"
            type="text"
            formControlName="lastName"
            onlyAlphabets
            class="form-control col-left text-capitalize form-field-black fs-exclude"
            aria-labelledby="cac-personal-label-lastName"
            name="lastName"
            maxLength="{{ nameMaxLength }}"
            (blur)="
              [
                removeTrailingSpaces($event, 'lastName'),
                parseInputAndValidate($event, 'lastName')
              ]
            "
            pattern="[a-zA-Z\s]+"
          />
          <span
            *ngIf="f.lastName.touched && f.lastName.errors?.isNotEmpty"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          *ngIf="f.lastName.value.length === nameMaxLength"
          role="alert"
          aria-atomic="true"
          class="helper-text"
        >
          Maximum number of characters reached
        </div>
        <div class="mobileOnly mobileDiv">
          <div
            *ngIf="f.lastName.touched && f.lastName.errors?.isNotEmpty"
            role="alert"
            aria-atomic="true"
            class="errWidthM required validation-error"
          >
            {{ formFieldData?.formsFields?.lastName?.errors?.lne1 }}
          </div>
          <div
            *ngIf="f.lastName.touched && f.lastName.errors?.isNotProfanity"
            role="alert"
            aria-atomic="true"
            data-testid="lastName-profanity"
            class="errWidthM required validation-error"
          >
            {{ globalText?.errors?.proferr1 }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group desktop">
      <div class="custom-display-inline col-md-8">
        <div
          *ngIf="f.firstName.touched && f.firstName.errors?.isNotEmpty"
          role="alert"
          aria-atomic="true"
          class="errWidthM required validation-error"
        >
          {{ formFieldData?.formsFields?.firstName?.errors?.fne1 }}
        </div>
        <div
          *ngIf="f.firstName.touched && f.firstName.errors?.isNotProfanity"
          role="alert"
          aria-atomic="true"
          data-testid="firstName-profanity"
          class="errWidthM required validation-error"
        >
          {{ globalText?.errors?.proferr1 }}
        </div>
      </div>
      <div class="custom-display-inline desktop col-md-8">
        <div
          *ngIf="f.lastName.touched && f.lastName.errors?.isNotEmpty"
          role="alert"
          aria-atomic="true"
          class="errWidthM required validation-error"
        >
          {{ formFieldData?.formsFields?.lastName?.errors?.lne1 }}
        </div>
        <div
          *ngIf="f.lastName.touched && f.lastName.errors?.isNotProfanity"
          role="alert"
          aria-atomic="true"
          data-testid="lastName-profanity"
          class="errWidthM required validation-error"
        >
          {{ globalText?.errors?.proferr1 }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-personal-div-email"
          class="form-group"
          [class.has-error]="f.email.touched && f.email.errors"
        >
          <p
            id="cac-personal-label-email"
            htmlFor="email"
            class="form-field-black control-label"
            [class.validation-error]="f.email.touched && f.email.errors"
          >
            {{ formFieldData?.formsFields?.email?.label }}
          </p>

          <input
            id="cac-personal-email"
            type="text"
            formControlName="email"
            class="form-control col-left fs-mask form-field-black fs-exclude"
            aria-labelledby="cac-personal-label-email"
            name="email"
            maxLength="{{ emailMaxLength }}"
            defaultValue="{this.props.personal.email}"
            (blur)="
              [
                removeTrailingSpaces($event, 'email'),
                parseInputAndValidate($event, 'email'),
                compareEmails()
              ]
            "
          />
          <span
            *ngIf="f.email.touched && f.email.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div class="mobileOnly mobileDiv">
          <div
            *ngIf="f.email.touched && f.email.errors?.isNotEmpty"
            role="alert"
            aria-atomic="true"
            data-testid="email-empty"
            class="Erremail errWidthL mobileOnly required validation-error"
          >
            {{ formFieldData?.formsFields?.email?.errors?.ee1 }}
          </div>
          <div
            *ngIf="f.email.touched && f.email.errors?.isNotProfanity"
            role="alert"
            aria-atomic="true"
            data-testid="email-profanity"
            class="errWidthM required validation-error"
          >
            {{ globalText?.errors?.proferr1 }}
          </div>
          <div
            *ngIf="f.email.touched && f.email.errors?.isEmail"
            role="alert"
            aria-atomic="true"
            data-testid="email-bad-format"
            class="Erremail errWidthL mobileOnly required validation-error"
          >
            {{ formFieldData?.formsFields?.email?.ee2 }}
          </div>
          <div
            class="disclosure col-left"
            [innerHTML]="emailDisclosure | safeHtml"
          ></div>
        </div>
      </div>
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-personal-div-email-confirmation"
          class="form-group"
          [class.has-error]="
            f.emailConfirmation.touched && f.emailConfirmation.errors
          "
        >
          <p
            id="cac-personal-label-emailConfirmation"
            htmlFor="emailConfirmation"
            class="control-label form-field-black"
            [class.validation-error]="
              f.emailConfirmation.touched && f.emailConfirmation.errors
            "
          >
            {{ formFieldData?.formsFields?.confirmEmail?.label }}
          </p>

          <input
            id="cac-personal-emailConfirmation"
            type="text"
            autocomplete="disabled"
            (paste)="(false)"
            (copy)="(false)"
            (cut)="(false)"
            (dragstart)="(false)"
            (drop)="(false)"
            (selectstart)="(false)"
            formControlName="emailConfirmation"
            (blur)="
              [
                removeTrailingSpaces($event, 'emailConfirmation'),
                parseInputAndValidate($event, 'emailConfirmation'),
                compareEmails()
              ]
            "
            class="form-control col-left fs-mask form-field-black fs-exclude"
            aria-labelledby="cac-personal-label-emailConfirmation"
            name="emailConfirmation"
            maxLength="{{ emailMaxLength }}"
            defaultValue="{this.props.personal.email}"
          />
          <span
            *ngIf="f.emailConfirmation.touched && f.emailConfirmation.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div class="mobileOnly mobileDiv">
          <div
            *ngIf="
              f.emailConfirmation.touched &&
              f.emailConfirmation.errors?.isNotEmpty
            "
            role="alert"
            aria-atomic="true"
            class="Erremail errWidthL mobileOnly required validation-error"
          >
            {{ formFieldData?.formsFields?.confirmEmail?.errors?.cee1 }}
          </div>
          <div
            *ngIf="
              f.emailConfirmation.touched &&
              f.emailConfirmation.errors?.isNotProfanity
            "
            role="alert"
            aria-atomic="true"
            data-testid="emailConfirmation-profanity"
            class="errWidthM required validation-error"
          >
            {{ globalText?.errors?.proferr1 }}
          </div>
          <div
            *ngIf="
              f.emailConfirmation.touched &&
              f.emailConfirmation.errors &&
              !f.emailConfirmation.errors.isNotEmpty &&
              f.emailConfirmation.errors.isEmail
            "
            role="alert"
            aria-atomic="true"
            class="Erremail errWidthL mobileOnly required validation-error"
          >
            {{ formFieldData?.formsFields?.confirmEmail?.errors?.cee3 }}
          </div>
          <div
            *ngIf="
              f.emailConfirmation.value &&
              f.email.value &&
              (f.emailConfirmation.errors?.emailMismatch ||
                !emailsAreValidAndMatching)
            "
            role="alert"
            aria-atomic="true"
            data-testid="emails-not-matching"
            class="required validation-error"
          >
            {{ formFieldData?.formsFields?.confirmEmail?.errors?.cee2 }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group desktop">
      <div class="custom-display-inline col-md-8">
        <div
          *ngIf="f.email.touched && f.email.errors?.isNotEmpty"
          role="alert"
          aria-atomic="true"
          class="required validation-error"
        >
          {{ formFieldData?.formsFields?.email?.errors?.ee1 }}
        </div>
        <div
          *ngIf="f.email.touched && f.email.errors?.isNotProfanity"
          role="alert"
          aria-atomic="true"
          data-testid="email-profanity"
          class="errWidthM required validation-error"
        >
          {{ globalText?.errors?.proferr1 }}
        </div>
        <div
          *ngIf="
            f.email.touched &&
            f.email.errors &&
            !f.email.errors.isNotEmpty &&
            f.email.errors.isEmail
          "
          role="alert"
          aria-atomic="true"
          class="required validation-error"
        >
          {{ formFieldData?.formsFields?.email?.errors?.ee2 }}
        </div>
        <div
          class="disclosure col-left"
          [innerHTML]="emailDisclosure | safeHtml"
        ></div>
        <!-- <div *ngIf="!isFlowSyca" class="disclosure"><journal [title]="emailDisclosure"></journal></div> -->
      </div>

      <div class="custom-display-inline col-md-8 float-right">
        <div
          *ngIf="
            f.emailConfirmation.touched &&
            f.emailConfirmation.errors?.isNotEmpty
          "
          role="alert"
          aria-atomic="true"
          class="required validation-error"
        >
          {{ formFieldData?.formsFields?.confirmEmail?.errors?.cee1 }}
        </div>
        <div
          *ngIf="
            f.emailConfirmation.touched &&
            f.emailConfirmation.errors?.isNotProfanity
          "
          role="alert"
          aria-atomic="true"
          data-testid="emailConfirmation-profanity"
          class="errWidthM required validation-error"
        >
          {{ globalText?.errors?.proferr1 }}
        </div>
        <div
          *ngIf="
            f.emailConfirmation.touched &&
            f.emailConfirmation.errors &&
            !f.emailConfirmation.errors.isNotEmpty &&
            f.emailConfirmation.errors.isEmail
          "
          role="alert"
          aria-atomic="true"
          class="required validation-error"
        >
          {{ formFieldData?.formsFields?.confirmEmail?.errors?.cee3 }}
        </div>
        <div
          *ngIf="
            f.emailConfirmation.touched &&
            f.emailConfirmation.value &&
            f.email.value &&
            (f.emailConfirmation.errors?.emailMismatch ||
              !emailsAreValidAndMatching) &&
            !(f.emailConfirmation.errors && f.emailConfirmation.errors.isEmail)
          "
          role="alert"
          aria-atomic="true"
          class="required validation-error"
        >
          {{ formFieldData?.formsFields?.confirmEmail?.errors?.cee2 }}
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-personal-div-date-of-birth"
          class="form-group"
          [class.has-error]="
            (f.dateOfBirth.touched && f.dateOfBirth.errors) ||
            underAgeError ||
            dateOfBirth18YearsOfAgeFlag
          "
        >
          <p
            id="cac-personal-label-date-of-birth"
            htmlFor="dateOfBirth"
            class="control-label form-field-black"
            [class.validation-error]="
              (f.dateOfBirth.touched && f.dateOfBirth.errors) ||
              underAgeError ||
              dateOfBirth18YearsOfAgeFlag
            "
          >
            {{ formFieldData?.formsFields?.dob?.label }}
          </p>

          <input
            id="cac-personal-date-of-birth"
            type="text"
            inputmode="numeric"
            formControlName="dateOfBirth"
            aria-labelledby="cac-personal-label-date-of-birth"
            placeholder="MM/DD/YYYY"
            class="form-control col-right form-field-black fs-exclude"
            name="dateOfBirth"
            maxLength="10"
            mask="00/00/0000"
            [dropSpecialCharacters]="false"
            (blur)="parseInputAndValidate($event, 'dateOfBirth')"
          />
          <span
            *ngIf="
              (f.dateOfBirth.touched &&
                f.dateOfBirth.errors &&
                (f.dateOfBirth.errors.required ||
                  f.dateOfBirth.errors.invalidDateFormat)) ||
              (!f.dateOfBirth.errors && underAgeError) ||
              dateOfBirth18YearsOfAgeFlag
            "
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div class="mobileOnly mobileDiv">
          <div
            *ngIf="
              f.dateOfBirth.touched &&
              f.dateOfBirth.errors &&
              f.dateOfBirth.value !== '' &&
              (f.dateOfBirth.errors.isDate ||
                f.dateOfBirth.errors.isOfAgeOrYounger)
            "
            role="alert"
            aria-atomic="true"
            class="ErrdateOfBirth errWidthL mobileOnly required validation-error"
          >
            {{ formFieldData?.formsFields?.dob?.errors?.dobe2 }}
          </div>
          <div
            *ngIf="
              f.dateOfBirth.touched &&
              f.dateOfBirth.errors &&
              f.dateOfBirth.errors.isNotEmpty
            "
            role="alert"
            aria-atomic="true"
            class="ErrdateOfBirth errWidthL mobileOnly required validation-error"
          >
            {{ formFieldData?.formsFields?.dob?.errors?.dobe1 }}
          </div>
          <div
            *ngIf="f.dateOfBirth.errors && f.dateOfBirth.errors.isOfAgeOrOlder"
            role="alert"
            aria-atomic="true"
            class="ErrdateOfBirth errWidthL mobileOnly required validation-error"
          >
            {{ formFieldData?.formsFields?.dob?.errors?.dobe3 }}
          </div>
          <div
            *ngIf="dateOfBirth18YearsOfAgeFlag"
            role="alert"
            aria-atomic="true"
            class="ErrdateOfBirth errWidthL mobileOnly required validation-error"
          >
            {{ formFieldData?.formsFields?.dob?.errors?.dobe4 }}
          </div>
        </div>
      </div>
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-personal-div-phone"
          class="col-md-12 form-group"
          [class.has-error]="f.phone.touched && f.phone.errors"
        >
          <p
            id="cac-personal-label-phone"
            htmlFor="phone"
            class="control-label form-field-black"
            [class.validation-error]="f.phone.touched && f.phone.errors"
          >
            {{ formFieldData?.formsFields?.phone?.label }}
          </p>

          <input
            id="cac-personal-phone"
            formControlName="phone"
            type="string"
            inputmode="numeric"
            mask="000-000-0000"
            (blur)="parseInputAndValidate($event, 'phone')"
            class="form-control col-right form-field-black fs-mask"
            aria-labelledby="cac-personal-label-phone fs-exclude"
            name="phone"
          />
          <span
            *ngIf="f.phone.touched && f.phone.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div class="mobileOnly mobileDiv">
          <div
            *ngIf="f.phone.touched && f.phone.errors"
            role="alert"
            aria-atomic="true"
            class="Errphone errWidthL mobileOnly required validation-error"
          >
            {{ formFieldData?.formsFields?.phone?.errors?.pe1 }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group desktop">
      <div class="custom-display-inline col-md-8">
        <div
          *ngIf="
            f.dateOfBirth.touched &&
            f.dateOfBirth.errors &&
            f.dateOfBirth.value !== '' &&
            (f.dateOfBirth.errors.isDate ||
              f.dateOfBirth.errors.isOfAgeOrYounger)
          "
          role="alert"
          aria-atomic="true"
          class="ErrdateOfBirth errWidthL required validation-error"
        >
          {{ formFieldData?.formsFields?.dob?.errors?.dobe2 }}
        </div>
        <div
          *ngIf="
            f.dateOfBirth.touched &&
            f.dateOfBirth.errors &&
            f.dateOfBirth.errors.isNotEmpty
          "
          role="alert"
          aria-atomic="true"
          class="ErrdateOfBirth errWidthL required validation-error"
        >
          {{ formFieldData?.formsFields?.dob?.errors?.dobe1 }}
        </div>
        <div
          *ngIf="f.dateOfBirth.errors && f.dateOfBirth.errors.isOfAgeOrOlder"
          role="alert"
          aria-atomic="true"
          class="ErrdateOfBirth errWidthL required validation-error"
        >
          {{ formFieldData?.formsFields?.dob?.errors?.dobe3 }}
        </div>
        <div
          *ngIf="dateOfBirth18YearsOfAgeFlag"
          role="alert"
          aria-atomic="true"
          class="ErrdateOfBirth errWidthL required validation-error"
        >
          {{ formFieldData?.formsFields?.dob?.errors?.dobe4 }}
        </div>
      </div>
      <div class="custom-display-inline col-md-8">
        <div
          *ngIf="f.phone.touched && f.phone.errors"
          role="alert"
          aria-atomic="true"
          class="required validation-error"
        >
          {{ formFieldData?.formsFields?.phone?.errors?.pe1 }}
        </div>
      </div>
    </div>
    <div class="col-md-12 form-group center desktop-97-5"></div>
  </form>
</div>
